import styled from "styled-components";
import { Modal } from "antd";
import { AccountInfo } from "./AccountInfo";

export const AccountInfoModal = styled(BaseAccountInfoModal)`
  @media (min-width:961px)  {
    .account-info #edit-account {
      padding: 20px 0 0 0;
      width: 100%;
    }
  }

  .info-form-buttons {
    margin: 0;
  }
`

interface IAccountInfoModal {
  className?: string
  open: boolean,
  onClose?: () => void,
  unacknowledged?: boolean
}

function BaseAccountInfoModal({className, open, onClose, unacknowledged}: IAccountInfoModal) {
  return (
    <Modal
      className={className}
      open={open}
      onCancel={onClose}
      title="Complete your profile"
      footer={[]}
      destroyOnClose={true}
    >
      <AccountInfo unacknowledged={unacknowledged} />
    </Modal>
  )
}